const LOGOUT_BROADCAST_TIMEOUT_MS = 500;

export const CHAT_USER_LOGOUT_EVENT = "chat-user-logout";
export const CHAT_USER_LOGOUT_BROADCAST_EVENT = "chat-user-explicit-logout";

type LogoutBroadcaster = (userId: string) => Promise<void>;

let logoutBroadcaster: LogoutBroadcaster | null = null;

export function registerChatUserLogoutBroadcaster(
  broadcaster: LogoutBroadcaster | null
) {
  logoutBroadcaster = broadcaster;
}

export async function broadcastChatUserLogout(userId: string) {
  if (!userId) return;

  const broadcaster = logoutBroadcaster;
  if (!broadcaster) return;

  try {
    await Promise.race([
      broadcaster(userId),
      new Promise<void>((resolve) => {
        const timeout = setTimeout(() => {
          clearTimeout(timeout);
          resolve();
        }, LOGOUT_BROADCAST_TIMEOUT_MS);
      }),
    ]);
  } catch {
    // silent by design
  }
}

export function dispatchChatUserLogout(userId: string) {
  if (typeof window === "undefined" || !userId) return;

  window.dispatchEvent(
    new CustomEvent(CHAT_USER_LOGOUT_EVENT, { detail: { userId } })
  );
}